import { jsx as _jsx } from "react/jsx-runtime";
import { fontSize } from "../../../core/design-system/index.js";
import { useChainName } from "../../../core/hooks/others/useChainQuery.js";
import { Skeleton } from "./Skeleton.js";
import { Text } from "./text.js";
/**
 * @internal
 */
export const ChainName = (props) => {
    const { name } = useChainName(props.chain);
    if (name) {
        return (_jsx(Text, { size: props.size, children: props.short ? shorterChainName(name) : name }));
    }
    return _jsx(Skeleton, { width: "50px", height: fontSize[props.size] });
};
function shorterChainName(name) {
    const split = name.split(" ");
    const wordsToRemove = new Set(["mainnet", "testnet", "chain"]);
    return split
        .filter((s) => {
        return !wordsToRemove.has(s.toLowerCase());
    })
        .join(" ");
}
//# sourceMappingURL=ChainName.js.map